class DeviceDetectionService {
  constructor() {
    this.TABLET_MIN_WIDTH = 768;
    this.DESKTOP_MIN_WIDTH = 1400;
  }

  isMobileDevice() {
    return window.innerWidth < this.TABLET_MIN_WIDTH;
  }

  isTabletOrSmaller() {
    return window.innerWidth < this.DESKTOP_MIN_WIDTH;
  }

  isTouchDevice() {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  isPWASupported() {
    return 'serviceWorker' in navigator;
  }

  getDeviceInfo() {
    return {
      isMobile: this.isMobileDevice(),
      isTablet: window.innerWidth >= this.TABLET_MIN_WIDTH && 
                window.innerWidth < this.DESKTOP_MIN_WIDTH,
      isDesktop: window.innerWidth >= this.DESKTOP_MIN_WIDTH,
      isTouch: this.isTouchDevice(),
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
    };
  }
}

export const deviceDetectionService = new DeviceDetectionService();